import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { logout as authLogout } from "../utils/auth";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const Navbar = ({ isAuth, updateAuthStatus }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    authLogout();
    if (updateAuthStatus) updateAuthStatus();
    handleClose();
    navigate("/login");
  };

  // Функция для проверки активного пути
  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  // Стиль для активной кнопки
  const activeButtonStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.25)',
    }
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            Rentiga
          </Link>
        </Typography>
        
        {isAuth ? (
          <>
            {/* Для десктопа */}
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <Button 
                color="inherit" 
                component={Link} 
                to="/organizations"
                sx={isActive("/organizations") ? activeButtonStyle : {}}
              >
                Организации
              </Button>
              <Button 
                color="inherit" 
                component={Link} 
                to="/devices"
                sx={isActive("/devices") ? activeButtonStyle : {}}
              >
                Устройства
              </Button>
              <Button 
                color="inherit" 
                onClick={handleLogout}
              >
                Выйти
              </Button>
            </Box>
            
            {/* Для мобильных */}
            <Box sx={{ display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                edge="end"
                color="inherit"
                onClick={handleMenu}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem 
                  onClick={() => { handleClose(); navigate("/organizations"); }}
                  selected={isActive("/organizations")}
                >
                  Организации
                </MenuItem>
                <MenuItem 
                  onClick={() => { handleClose(); navigate("/devices"); }}
                  selected={isActive("/devices")}
                >
                  Устройства
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  Выйти
                </MenuItem>
              </Menu>
            </Box>
          </>
        ) : (
          <Button 
            color="inherit" 
            component={Link} 
            to="/login"
            sx={isActive("/login") ? activeButtonStyle : {}}
          >
            Войти
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;